import makeStyles from "@material-ui/core/styles/makeStyles"

export const useMoveWrapStyle = makeStyles({
    root: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
    },
})
